import {
  InstanceConfiguration,
  UpdateInstanceConfigurationRequest,
} from '../../types/instance-configuration';
import httpClient from '../http';

export const instanceConfigurationService = {
  getInstanceConfiguration: async (instanceId: string): Promise<InstanceConfiguration> => {
    const response = await httpClient.get<InstanceConfiguration>(
      `/backend/api/v1/instance-configuration/instances/${instanceId}`
    );
    return response.data;
  },

  updateInstanceConfiguration: async (
    instanceId: string,
    config: UpdateInstanceConfigurationRequest
  ): Promise<InstanceConfiguration> => {
    const response = await httpClient.put<InstanceConfiguration>(
      `/backend/api/v1/instance-configuration/instances/${instanceId}`,
      config
    );
    return response.data;
  },
};
